// extracted by mini-css-extract-plugin
module.exports = {"list":"notesListPanel_list__f8PFf","verticalButton":"notesListPanel_verticalButton__3R9nR"};